if (!customElements.get('grid-quick-add')) {
  customElements.define('grid-quick-add', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.closest('.bag-product-card')?.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.close();
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.busy && event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('grid:quick-add-open', event => {
        if (event.detail !== this) this.close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('.card-bag-toggle');
      this.panel = this.querySelector('.card-size-panel');
      this.toggle.addEventListener('click', event => {
        const open = this.panel.hidden;
        if (open) document.dispatchEvent(new CustomEvent('grid:quick-add-open', { detail: this }));
        this.setOpen(open);
        if (open && event.detail === 0) this.panel.querySelector('button:not(:disabled), a')?.focus();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.close();
          this.toggle.focus();
        }
      });
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.message = this.querySelector('.clean-card-message');
      this.form.addEventListener('submit', event => this.add(event));
    }

    disconnectedCallback() {
      this.lifecycle.abort();
    }

    setOpen(open) {
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      this.closest('.bag-product-card')?.classList.toggle('quick-add-open', open);
    }

    close() {
      this.setOpen(false);
    }

    notifyCartUpdated() {
      document.querySelectorAll('.wrapper-top-cart > .site-header_cart_link').forEach(link => {
        link.classList.remove('cart-updated');
        // Restart the existing cart-icon transition for every successful add.
        void link.offsetWidth;
        link.classList.add('cart-updated');
        window.setTimeout(() => link.classList.remove('cart-updated'), 450);
      });
    }

    async add(event) {
      event.preventDefault();
      const button = event.submitter;
      if (this.busy || !button || button.disabled) return;
      const body = new FormData(this.form);
      body.set('id', button.value);
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.message.textContent = '';
      const enabled = [...this.querySelectorAll('button[type="submit"]:not(:disabled)')];
      enabled.forEach(el => { el.dataset.inFlight = ''; el.disabled = true; });
      try {
        const response = await fetch(this.form.action + '.js', {
          method: 'POST', body, headers: { Accept: 'application/json' }
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        this.message.textContent = this.dataset.success;
        if (typeof window.animateProductToCart === 'function') window.animateProductToCart(this.form);
        let cart;
        // Use one current cart snapshot for both the header count and mini-cart.
        try {
          const root = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(root + 'cart.js');
          if (cartResponse.ok) {
            cart = await cartResponse.json();
            document.querySelectorAll('.cart-products-count').forEach(el => { el.textContent = cart.item_count; });
          }
        } catch (_) { /* The cart-added listener will request a fresh cart as a fallback. */ }
        document.dispatchEvent(new CustomEvent('grid:cart-added', { detail: { item: result, cart } }));
        this.notifyCartUpdated();
        if (window.matchMedia('(max-width: 991px)').matches) this.close();
      } catch (error) {
        this.message.textContent = error.message || this.dataset.error;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        enabled.forEach(el => { el.disabled = false; delete el.dataset.inFlight; });
      }
    }
  });
}
